import { PropsWithChildren } from "react";
import { PDFViewerProvider } from "../../contexts/pdfViewer";
import * as UI from './styles';

const PDFTemplate = ({ children }: PropsWithChildren<any>) => {
    return (
        <UI.Container>
            <PDFViewerProvider>
                {children}
            </PDFViewerProvider>
        </UI.Container>
    );
}

export default PDFTemplate;